import EmailNotification from 'models/notification/email/EmailNotification';

/**
 * Class representing a registration email notification.
 * @extends EmailNotification
 */
export default class RegistrationEmailNotification extends EmailNotification {
	_type = 'registration';
}
